import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  const [joke, setJoke] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://icanhazdadjoke.com/', {
          headers: {
            Accept: 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const jsonResponse = await response.json();
        setJoke(jsonResponse.joke);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    // Hämta data endast om det inte redan finns
    if (joke === '') {
      fetchData();
    }
  }, [joke]);


  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-4 text-center">
      <h1 className="font-mono text-7xl font-semibold tracking-tight text-sky-500">404</h1>
      <p className="lead max-w-md">
        Sidan kunde inte hittas, men jag kan bjuda på ett skämt istället?
        <br />
        <br />
        {joke}
      </p>
      <Link
        to="/"
        className="btn-primary"
      >
        Till startsidan
      </Link>
    </div>
  );
};

export default NotFoundPage;